import { render } from "./DataHobi.vue?vue&type=template&id=925a8dca"
import script from "./DataHobi.vue?vue&type=script&lang=js"
export * from "./DataHobi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__